import { render } from "./B2CMailNotificationPopup.vue?vue&type=template&id=08faec60&scoped=true&lang=pug"
import script from "./B2CMailNotificationPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./B2CMailNotificationPopup.vue?vue&type=script&setup=true&lang=js"

import "./B2CMailNotificationPopup.vue?vue&type=style&index=0&id=08faec60&lang=sass&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08faec60"]])

export default __exports__